export class Socket {
  userId;
  roomId;
  listeners;
  connected;
  onOpenCallback;
  onErrorCallback;
  onCloseCallback;

  constructor(userId, role) {
    if (typeof Socket.instance === "object") {
      return Socket.instance;
    }

    this.userId = userId;
    this.roomId = '';
    this.connected = false;
    this.listeners = [];
    this.worker = new Worker(new URL('./worker.js', import.meta.url), {type: 'module'});
    this.onOpenCallback = ()=>{};
    this.onErrorCallback = ()=>{};
    this.onCloseCallback = ()=>{};

    this.worker.onmessage = (event) => {
      const { type, data } = event.data;
      
      switch (type) {          
        case 'socket_connected':
          this.onOpenCallback()
          this.connected = true;
          break;
          
        case 'socket_message':
          this.send(data);
          break;
          
        case 'socket_error': 
          this.error();
          this.onErrorCallback();
          break; 

        case 'socket_closed':
          this.close();
          break;

        case 'socket_reconnect_failed':
          this.close();
          this.reconnectFailed();
          break;

        default: 
          this.listeners.forEach(cb => cb(event.data));
          break;
      }
    };
  }

  initListeners(onOpen, onError, onClose) {
    //console.log('[Socket] Init Listeners...')
    this.onOpenCallback = onOpen;
    this.onErrorCallback = onError;
    this.onCloseCallback = onClose;
    this.roomId = window.roomId;
    const accessToken = localStorage.getItem('token');

    this.worker.postMessage({
      type: 'init', 
      payload: {
        userId: this.userId,
        token: accessToken
      }
    });
  }

  isConnected() {
    return this.connected;
  }

  send(event, data = {}) {
    this.worker.postMessage({
      type: 'send_message',
      payload: {
        event,
        data
      }
    });
  }

  listen(callback) {
    const listenersMap = this.listeners.reduce((map, lsr) => {
      map.set(lsr.toString(), lsr);

      return map;
    }, new Map());

    listenersMap.set(callback.toString(), callback);
    this.listeners = Array.from(listenersMap.values());
  }

  stopListening(callback) {
    this.listeners = this.listeners.filter(l => l !== callback);
  }

  reconnect() {
    console.log('[Socket] Reconnect...')
    setTimeout(() => {
      this.initListeners(this.onOpenCallback, this.onErrorCallback, this.onCloseCallback);
    }, 2000);
  }

  close() {
    //console.log('[Socket] Close')
    this.connected = false;
    this.onCloseCallback();
  }

  error() {
    //console.log('[Socket] Error')
    this.connected = false;
    this.onErrorCallback();
  }

  reconnectFailed() {
    //console.log('[Socket] Reconnect failed')
    this.connected = false;
    this.onReconnectError();
  }

  onReconnectError() {}
};
